export default class EPGConfig {
    static ChannelRowHeight = 72
    static ChannelWidth = 470
    static pixelPer30m = 450
    static pixelPerHour = 450*2
}
